import Request from "../request";
const request = new Request();

export class InquiryService {
  static getData() {
    throw new Error("Method not implemented.");
  }
  static list = async (
    // individual: any,
    // type: any,
    // status: any,
    // key: any,
    // value: any,
    // order: any,
    offset: any,
    limit: any
  ) => {
    console.log(offset);

    // const res = await request.get(
    //   `inquiry/base/list?individual=${individual}&type=${type}&status=${status}&key=${key}&value=${value}&order=${order}&offset=${offset}&limit=${limit}`
    // );

    const res = await request.get(`inquiry/base/list?offset=${offset}&limit=${limit}`);
    // const res = await request.get(
    //   `inquiry/base/list?individual=${individual}&type=${type}&status=${status}&key=${key}&value=${value}&order=${order}&offset=${offset}&limit=${limit}`
    // );
    // // const res = await request.get(
    //   "inquiry/base/list?" +
    //     `individual=${individual}&type=${type}&status=${status}&key=${key}&value=${value}&order=${order}&offset=${offset}&limit=${limit}`
    // );
    return res.data;
  };

  static create = async (data: any) => {
    await request.post("/inquiry/base/list?", data);
  };

  static update = async (data: any, userKey: any) => {
    await request.patch("/inquiry/base/list?" + userKey, data);
  };

  static view = async (userKey: any) => {
    const res = await request.get("/inquiry/base/list?" + userKey);
    return res.data;
  };

  static list2 = async (
    processYN: string,
    sort: string,
    search: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    let params = "";

    if (processYN) {
      params += `processYN=${processYN}&`;
    }
    if (sort) {
      params += `sort=${sort}&`;
    }
    if (search) {
      params += `search=${search}&`;
    }
    if (startDate) {
      params += `startDate=${startDate}&`;
    }
    if (endDate) {
      params += `endDate=${endDate}&`;
    }
    if (limit) {
      params += `limit=${limit}&`;
    }
    if (page) {
      params += `page=${page}&`;
    }

    const { data } = await request.get("/inquiry" + (params ? "?" + params.slice(0, -1) : ""));

    return data.data;
  };

  static updateState = async (inquiryId: string) => {
    await request.patch(`/inquiry/${inquiryId}`);
  };

  static answer = async (inquiryId: number, answer: string) => {
    const data = {
      answer: answer,
    };

    await request.post(`/inquiry/${inquiryId}`, data);
  };
}
